import * as React from 'react';

export interface IEarningsSettingsProps {
}

export function EarningsSettings(props: IEarningsSettingsProps) {
    return (
        <div className="text-left mt-8" >
            <h1 className="text-xl sm:text-2xl xl:text-3xl font-extrabold text-cusBlack dark:text-white">Earnings</h1>
            <p className="text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2">To access your 2021 Creator Earnings from NFT sales with this wallet using UNC, see below.
                <br />
                <br />
                As a reminder, you are solely responsible for validating this information and determining what, if any, taxes apply to your NFT sales and/or creator earnings. UNC cannot determine for you what taxes you owe. For any questions, please reach out to xxxx@unsea.io.
                <br />
                <br />
                Note - this report does not include earnings from NFT sales where you are not the creator, and does not include fees earned on Polygon or Klaytn. For information on your other UNC activity, refer to the Activity tab.</p>


        </div>
    );
}
